<template>
  <!-- BEGIN: Content-->
  <div class="body-login">
    <div class="content-overlay" />
    <div class="content-wrapper">
      <div class="content-header row" />
      <div class="content-body">
        <div class="auth-wrapper auth-cover">
          <div class="auth-inner row m-0">
            <!-- Brand logo-->
            <a
              class="brand-logo"
              href="https://www.icrea.cat"
            />

            <!-- /Brand logo-->
            <!-- Left Text-->
            <div
              class="d-none d-lg-flex col-lg-8 align-items-center p-5"
              :style="{'background': 'url(' + require('@/assets/images/illustration/bg-login.svg') + ') center center no-repeat', 'background-size': 'cover'}"
            >
              <div class="w-100 d-lg-flex align-items-center justify-content-center flex-column px-5">
                <div class="mb-4">
                  <img
                    class="img-fluid"
                    :src="require('@/assets/images/logo/logo-icrea-white-login.svg')"
                    alt="ICREA"
                  >
                </div>
                <!-- <div class="quote">
                  <h1><em>"You never fail until you stop trying"</em></h1>
                  <hr>
                  <p>Albert Einstein</p>
                </div> -->
              </div>
            </div>
            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h2 class="card-title fw-bold mb-1">
                  Registration finished
                </h2>
                <p class="card-text">
                  You will receive an email with the confirmation.
                </p>
                <p class="card-text">
                  You can now start the registration process for the call
                </p>
                <p class="mb-2">
                  <a
                    title="start the process"
                    class="btn btn-primary"
                    @click="$router.push({ name: 'front.academy-call' })"
                  >Start the process</a>
                </p>
                <hr>
                <h3>Your registration data</h3>
                <p><strong class="d-block">Name</strong>{{ user.name }}</p>
                <p><strong class="d-block">Email</strong>{{ user.email }}</p>

              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { mapGetters } from 'vuex'

require('@core/scss/core.scss')
require('@/assets/scss/style.scss')

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
}
</script>

<style>

</style>
